<script setup lang="ts">
import '@/assets/scss/form.scss';
import CSInputText from '@/onenetwork/components/form/CSInputText.vue';
import ImagePicker from '@/onenetwork/components/image_picker/ImagePicker.vue';
import RegionPicker from '@/onenetwork/components/region_picker/RegionPicker.vue';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import { useConfirm } from 'primevue';
import { useToast } from 'primevue/usetoast';
import { nextTick, ref, watch } from 'vue';
import { uuid } from 'vue3-uuid';
import AccountAPI from '../constants/account.api.uri.const';
import { accountTypeOptions, initialValuesAccount, parseFormDataAccount, statusOptions } from '../helper/form';
import { schemaUpdateAccount } from '../helper/validationAccountSchema';
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue';
import { Icon } from '@iconify/vue/dist/iconify.js';
import CsButton from '@/components/ui/button/CsButton.vue'

const confirm = useConfirm();
const editable = ref(false)


interface Props {
  account: any,
  isUpdate?: boolean
}

const props = defineProps<Props>()
const toast = useToast();
const formRef = ref();
const loading = ref(false);
const initialValues = ref(initialValuesAccount(props.account));
const selectedRegion = ref([])
const selectedDistrict = ref([])
const selectedWard = ref([])

const resolver = yupResolver(schemaUpdateAccount);

const updateAccount = async (data: any) => {
  loading.value = true
  try{
    const res = await APIClient.put(AccountAPI.account.update.replace(':id', data.id), data);
    if (res.data.code === 200) {
      toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thành công', life: 3000 });
      initialValues.value = initialValuesAccount(res.data.data);
      editable.value = false
      loading.value = false
      nextTick(() => {
        formRef.value?.reset();
      })
      return;
    }
  } catch (e: any) {
    loading.value = false;
    const errorMessage = e.response?.data?.errors[0]?.error || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
  }
}

const onFormSubmit = async ({values, valid}: {values: Record<string, any>, valid: boolean}) => {
  console.log(61, 'onFormSubmit', valid)
  if (!valid) {
    return;
  }
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {
      updateAccount(parseFormDataAccount({...initialValues.value, ...values}));
    },
    reject: () => {
    }
  });
};

const handleChangeAvatar = (data: any) => {
  console.log(84, data)
  formRef.value?.setFieldValue('profile_image', data?.uuid);

}

watch(() => props.account, () => {
  initialValues.value = initialValuesAccount(props.account)
}, {immediate: true, deep: true})

const handleRegionChange = (value: any) => {

  if (value[0]?.id) {
    initialValues.value.province_id = value[0]?.id
    formRef.value?.setFieldValue('province_id', value[0]?.id)
  } else {
    initialValues.value.province_id = null
    formRef.value?.setFieldValue('province_id', null)
  }
  selectedDistrict.value = [];
  selectedWard.value = [];
}

const handleDistrictChange = (value: any) => {
  if (value[0]?.id) {
    initialValues.value.district_id = value[0]?.id
    formRef.value?.setFieldValue('district_id', value[0]?.id)
  } else {
    initialValues.value.district_id = null
    formRef.value?.setFieldValue('district_id', null)
  }
  selectedWard.value = [];
}

const handleWardChange = (value: any) => {
  if (value[0]?.id) {
    initialValues.value.ward_id = value[0]?.id
    formRef.value?.setFieldValue('ward_id', value[0]?.id)
  } else {
    initialValues.value.ward_id = null
    formRef.value?.setFieldValue('ward_id', null)
  }
}

const cancelEdit = () => {
  editable.value = false
  initialValues.value.province_id = initialValues.value?.province?.id
  initialValues.value.district_id = initialValues.value?.district?.id
  initialValues.value.ward_id = initialValues.value?.ward?.id
  formRef.value?.reset()
}

</script>

<template>
  <div class="flex-1 flex-col md:flex-5 md:border-r md:border-[#ebebeb] md:pr-5">
    <div class="flex justify-between" v-if="isUpdate">
      <div></div>
      <div class="flex gap-2">
        <AllowPerm perm="account.edit_info" action="hide">
          <!-- <button type="button" class="btn btn-cs outline" v-if="!editable" @click="()=>{
            editable = true
          }">
            <span>Chỉnh sửa</span>
          </button>
          <button type="button" class="btn btn-cs outline" v-if="editable" @click="cancelEdit">
            <span>Huỷ chỉnh sửa</span>
          </button> -->

          <CsButton
            type="button"
            icon="ri:edit-2-fill"
            text="Chỉnh sửa"
            :visible="!editable"
            @click="editable = true"
          />
          <CsButton
            type="button"
            icon="ri:close-circle-fill"
            text="Huỷ chỉnh sửa"
            variant="danger"
            :visible="editable"
            @click="cancelEdit"
          />
        </AllowPerm>
      </div>
    </div>
    <Form
      v-slot="$form"
      ref="formRef"
      :initial-values="initialValues"
      :resolver="resolver"
      @submit="onFormSubmit"
      class="flex flex-col md:flex-row w-full pt-3 gap-y-5"
    >
<!--      <InputText name="profile_image" type="text" hidden class="form-control" />-->
<!--      <InputText name="province_id" type="text" hidden class="form-control" />-->
<!--      <InputText name="district_id" type="text" hidden class="form-control" />-->
      <InputText name="ward_id" type="text" hidden class="form-control" />
      <div class="flex w-full md:flex-1 mb-5" v-if="editable">
        <image-picker
          type="photo"
          :readonly="!editable"
          :uuid="uuid.v4().toString()"
          :src="initialValues?.avatar"
          folder="user"
          height="250px"
          :upload="true"
          @action:upload-success="handleChangeAvatar"/>
      </div>
      <div class="flex w-full md:flex-1 mb-5" v-else>
        <image-picker readonly height="250px" folder="user" type="photo" :src="initialValues?.avatar"/>
      </div>
      <div class="flex flex-col w-full md:flex-3">
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Mã tài khoản:</div>
          <div class="flex-2">
            <InputText name="code" type="text" class="form-control" disabled />
          </div>
        </div>
<!--        <div class="flex mb-3 gap-3 hidden">-->
<!--          <div class="flex-1 text-right">Khu vực:</div>-->
<!--          <div class="flex-2">-->

<!--            <div class="flex gap-2 w-full">-->
<!--              <RegionPicker-->
<!--                level="region"-->
<!--                name="province_id"-->
<!--                v-model="selectedRegion"-->
<!--                @update:selected="handleRegionChange"-->
<!--                :selectedId="initialValues?.province_id"-->
<!--                :editable="!editable"-->
<!--                :error="$form.province_id?.error?.message"-->
<!--              />-->

<!--              <RegionPicker-->
<!--                level="district"-->
<!--                name="district_id"-->
<!--                :parentId="selectedRegion[0]?.id"-->
<!--                v-model="selectedDistrict"-->
<!--                @update:selected="handleDistrictChange"-->
<!--                :selectedId="initialValues?.district_id"-->
<!--                :editable="!editable"-->
<!--                :error="$form.district_id?.error?.message"-->
<!--              />-->
<!--              <RegionPicker-->
<!--                level="ward"-->
<!--                name="ward_id"-->
<!--                :regionId="selectedRegion[0]?.id"-->
<!--                :parentId="selectedDistrict[0]?.id"-->
<!--                v-model="selectedWard"-->
<!--                @update:selected="handleWardChange"-->
<!--                :selectedId="initialValues?.ward_id"-->
<!--                :editable="!editable"-->
<!--                :error="$form.ward_id?.error?.message"-->
<!--              />-->
<!--            </div>-->

<!--            <span class="italic text-[12px] text-red-500" v-if="$form.address?.invalid && editable">-->
<!--              {{ $form.address.error.message }}-->
<!--            </span>-->
<!--          </div>-->

<!--        </div>-->
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Họ và tên:</div>
          <div class="flex-2">
            <CSInputText :model-value="initialValues?.full_name" name="full_name" type="text" class="form-control" :editable="!editable"/>
            <span class="italic text-[12px] text-red-500" v-if="$form.full_name?.invalid && editable">
              {{ $form.full_name.error.message }}
            </span>

          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Số điện thoại:</div>
          <div class="flex-2">
            <CSInputText
              name="phone_number"
              :model-value="initialValues?.phone_number"
              :maxlength="10"
              class="form-control"
              :editable="!editable"
              @keypress="(e) => {
                const charCode = (e.which) ? e.which : e.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                  e.preventDefault();
                }
              }"
              @paste="(e: ClipboardEvent) => {
                e.preventDefault();
                const text = e.clipboardData?.getData('text') || '';
                const numbers = text.replace(/\D/g, '').slice(0, 10);
                formRef.value?.setFieldValue('phone_number', numbers);
              }"
            />
            <Message v-if="$form.phone_number?.invalid" severity="error" class="text-md italic" variant="simple">
              {{ $form.phone_number.error.message }}
            </Message>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Email:</div>
          <div class="flex-2">
            <CSInputText :model-value="initialValues?.email" name="email" type="text" class="form-control" :editable="!editable"/>
            <span class="italic text-[12px] text-red-500" v-if="$form.email?.invalid && editable">
              {{ $form.email.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Trạng thái hoạt động:</div>
          <div class="flex-2">
            <Select
              name="activation_status"
              :options="statusOptions"
              optionLabel="name"
              placeholder="Chọn trạng thái"
              class="form-control"
              :disabled="!editable"
            />
            <span class="italic text-[12px] text-red-500" v-if="$form.activation_status?.invalid && editable">
              {{ $form.activation_status.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Loại tài khoản:</div>
          <div class="flex-2">
            <Select name="account_type"
              :options="accountTypeOptions"
              optionLabel="name"
              placeholder="Chọn loại tài khoản"
              class="form-control"
              :disabled="true"/>
            <span class="italic text-[12px] text-red-500" v-if="$form.account_type?.invalid && editable">
              {{ $form.account_type.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Đổi mật khẩu:</div>
          <div class="flex-2">
            <CSInputText :model-value="initialValues?.password" name="password" type="password" class="form-control" :editable="!editable"/>
            <span class="italic text-[12px] text-red-500" v-if="$form.password?.invalid && editable">
              {{ $form.password.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Xác nhận mật khẩu:</div>
          <div class="flex-2">
            <CSInputText :model-value="initialValues?.password_confirmation" name="password_confirmation" type="password" class="form-control" :editable="!editable"/>
            <span class="italic text-[12px] text-red-500" v-if="$form.password_confirmation?.invalid">
              {{ $form.password_confirmation.error.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3" v-if="editable">
          <div class="flex-1 text-right"></div>
          <div class="flex-2">
            <CsButton
              type="submit"
              :disabled="loading"
              :loading="loading"
              text="Lưu chỉnh sửa"
            />
          </div>
        </div>
      </div>
    </Form>
  </div>

</template>
